import moment from "moment";
import empty from "is-empty";
import TruMath from "./math";
import $ from "jquery";
import { TX_PURPOSE_LABELS } from "../redux/Confirmations/constants";
window.jQuery = $;
try {
    require("jquery-titlealert");
} catch (e) {
    // fail while running the test. just ignore it
}

export const groupBy = function (xs, key) {
    //From StackOverflow
    return xs.reduce(function (rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
    }, {});
};

export const isCountryToCheckQty = function (country) {
    return country === "TW"; // not it's only TW
};

export const qtyByCountry = function (value, country, roundUp) {
    // TODO get count of DP by country
    if (value > 0 && isCountryToCheckQty(country)) {
        if (roundUp) {
            return Math.ceil(value / 1000) * 1000;
        } else {
            return Math.floor(value / 1000) * 1000;
        }
    }
    return value;
};

export const setDateFormat = function (date, separator) {
    const momentValue = date ? moment(date.toString()) : null;
    return momentValue && momentValue.isValid()
        ? momentValue.format(`YYYY${separator}MM${separator}DD`)
        : "";
};

const DatePatterns = {
    "YYYY/MM/DD": /^\d{4}[./-]\d{2}[./-]\d{2}$/,
    "M/DD/YYYY": /^\d[./-]\d{2}[./-]\d{4}$/,
    "MM/DD/YYYY": /^\d{2}[./-]\d{2}[./-]\d{4}$/,
};
export const unformatDate = (date) => {
    if (typeof date === "string") {
        for (const [format, regex] of Object.entries(DatePatterns)) {
            if (date.match(regex))
                return moment(date.replace(/[./-]/g, "/"), format);
        }
        return moment(date); // YYYYMMDD
    }
    // js date object
    return moment(date).startOf("day");
};

export const getTermFromDate = (startDate, endDate) => {
    if (empty(startDate) || empty(endDate)) return "";
    if (moment(endDate).format("YYYYMMDD") === "99991231") return "";
    let diff = moment(unformatDate(endDate)).diff(
        moment(unformatDate(startDate)),
        "days"
    );
    return diff >= 0 ? diff + 1 : diff;
};

export const getDateFromTerm = (startDate, term) => {
    if (empty(startDate) || empty(term)) return new Date("9999-12-31");
    return moment(unformatDate(startDate))
        .add(term - 1, "days")
        .toDate();
};

// eslint-disable-next-line no-control-regex
export const EMAIL_REGEX =
    /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;

export const alertTaskbar = (msg) => {
    // 1. makes title blink between original and given message
    window.jQuery.titleAlert(msg);

    // 2. if the website is pinned on ie11, make the taskbar flash
    try {
        if (window.external.msIsSiteMode()) {
            window.setTimeout(() => window.external.msSiteModeActivate(), 2000);
        }
    } catch (error) {
        // fail silently
    }
};

export const stopTaskbarBlinking = () => {
    window.jQuery.titleAlert.stop();
};

export const getVWAvgRateFromBps = (rows) => {
    return getVWAvgRate(rows) / 100;
};

export const getVWAvgRate = (rows) => {
    if (empty(rows)) return undefined;

    try {
        const hasInvalidData = rows.some(
            (row) => !TruMath.isNumber(row.rate) || !TruMath.isNumber(row.value)
        );
        if (hasInvalidData) return undefined;

        const totalValue = rows.reduce((total, row) => total + row.value, 0);
        if (!totalValue) return undefined; // 0, NaN, null, undefined

        const vwAvg = rows.reduce(
            (vwavg, row) => vwavg + row.rate * (row.value / totalValue),
            0
        );
        if (!vwAvg) return undefined; // 0, NaN, null, undefined

        return TruMath.round(vwAvg, 2);
    } catch (error) {
        console.log("error in getValueWeightedAverge: ", error);
        return undefined;
    }
};

export const getFilterOptionsFromResponseByKey = (data, key) => {
    if (!data || !Array.isArray(data)) {
        return [];
    }
    const uniqueValues = new Set();
    data.forEach((item) => {
        const value = item[key];
        if (value !== null && value !== undefined) {
            uniqueValues.add(value);
        }
    });
    return Array.from(uniqueValues);
};

export const getDefaultTxPurpose = (stockItem) => {
    return getDefaultTxPurposeForCountryCode(stockItem.countryCode);
};

export const getDefaultTxPurposeForCountryCode = (countryCode) => {
    return countryCode === "KR"
        ? TX_PURPOSE_LABELS.SHORT_SELLING.value
        : TX_PURPOSE_LABELS.NONE.value;
};

/// If 90 day max maturity is set, and the security is a Korean security with Purpose short selling,
/// then select the maximum possible maturity date based on the value date
export const getMaximumPossibleMaturityDate = (
    countryCode,
    purpose,
    valueDate,
    tradeableDates,
    maxMaturityDates,
    enable90DayMaxMaturity
) => {
    if (
        enable90DayMaxMaturity &&
        countryCode === "KR" &&
        purpose === TX_PURPOSE_LABELS.SHORT_SELLING.value
    ) {
        return getClampedOrMaximum90DayMaturityDate(
            undefined,
            valueDate,
            tradeableDates,
            maxMaturityDates,
            true
        );
    } else {
        return "9999-12-31";
    }
};

/// If 90 day max maturity is set, and the security is a Korean security with Purpose short selling,
/// then ensure the `maturity` does not exceed 90 days compared to the value date.
export const getClampedMaturityDate = (
    countryCode,
    purpose,
    maturity,
    valueDate,
    tradeableDates,
    maxMaturityDates,
    enable90DayMaxMaturity
) => {
    if (
        enable90DayMaxMaturity &&
        countryCode === "KR" &&
        purpose === TX_PURPOSE_LABELS.SHORT_SELLING.value
    ) {
        return getClampedOrMaximum90DayMaturityDate(
            maturity,
            valueDate,
            tradeableDates,
            maxMaturityDates,
            false
        );
    } else {
        return maturity ?? "9999-12-31";
    }
};

const getClampedOrMaximum90DayMaturityDate = (
    maturity,
    valueDate,
    tradeableDates,
    maxMaturityDates,
    maximizeDate
) => {
    if (!empty(valueDate) && !empty(maxMaturityDates)) {
        // find the maturity date +90 of the value date

        // this function is annoyingly called with completely different payloads
        const normalizedTradeableDates = tradeableDates.map((str) =>
            str.replace(/-/g, "")
        );

        // ditto here: pasting in Initiate with value date versus selecting the value date
        // in the calendar produces differently formatted dates.
        const normalizedValueDate = valueDate
            .replace(/-/g, "")
            .replace(/\//g, "");

        const index = normalizedTradeableDates.indexOf(normalizedValueDate);
        const maxMaturityDate = maxMaturityDates[index];

        if (maximizeDate) {
            return maxMaturityDate;
        } else {
            // else clamp it
            if (
                maturity === undefined ||
                /// This is necessary due to the UI passing around all kinds of different types of values:
                /// - In some cases it's a date string YYYY-MM-DD
                /// - In other cases it's a YYYY/MM/DD formatted string
                /// - Yet in other cases a Date object is passed (e.g. during Calendar selection)
                /// TODO: Fix the call site and make the front-end pass dates consistently.
                (maturity instanceof Date
                    ? maturity
                    : new Date(maturity.replace(/-/g, ""))) >
                    new Date(maxMaturityDate.replace(/-/g, ""))
            ) {
                return maxMaturityDate;
            } else {
                return maturity;
            }
        }
    }

    return undefined;
};
